export enum YouNoMoreOwnerSceneResult {
    SHOW_MARKETPLACE,
    NONE
}